import Tooltip from "@mui/material/Tooltip";
import { makeStyles, withStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
    popover: {
        pointerEvents: "none",
    },
    paper: {
        padding: theme.spacing(1),
    },
    content: {
        maxWidth: 400,
        
        padding: "8px 16px",
    },
}));

const LightTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: theme.palette.common.white,
        color: "rgba(0, 0, 0, 0.87)",
        boxShadow: theme.shadows[1],
        fontSize: 11,
        minWidth: 400,
        width: "auto",
    },
}))(Tooltip);

function AtsTooltip({ trigger, content, contentStyle }) {
    const classes = useStyles();

    const styleC = contentStyle ? contentStyle : {};
    const _content = (
        <div className={classes.content} style={styleC}>
            {content}
        </div>
    );
    return <LightTooltip title={_content}>{trigger}</LightTooltip>;
}
export default AtsTooltip;
